import {
  TablePseudoBottomBorderRow,
  TablePseudoBottomBorderRowProps,
} from "../TablePseudoBottomBorderRow"

export type TableHeaderRowProps = TablePseudoBottomBorderRowProps

export function TableHeaderRow({
  children,
  ref,
  ...otherProps
}: TableHeaderRowProps) {
  return (
    <TablePseudoBottomBorderRow ref={ref} {...otherProps}>
      {children}
    </TablePseudoBottomBorderRow>
  )
}
